import { useEffect } from 'react';

import AudacyLogger, { LoggerTopic } from '@audacy-clients/client-services/src/AudacyLogger';
import { getClientServices } from '@audacy-clients/core/utils/clientServices';
import { isChromeBrowser } from '~/utils/browser/isChromeBrowser';

const firePixel = (url: string): void => {
  const urlWithCb = `${url}${url.includes('?') ? '&' : '?'}cb=${Date.now()}`;

  try {
    const img = new Image(1, 1);
    img.referrerPolicy = 'no-referrer-when-downgrade';
    img.width = 1;
    img.height = 1;
    img.style.position = 'absolute';
    img.style.left = '-9999px';
    img.style.top = '0';
    img.alt = '';

    img.onload = () => {
      try {
        img.remove();
      } catch {}
    };
    img.onerror = () => {
      try {
        img.remove();
      } catch {}
    };

    if (typeof document !== 'undefined' && document.body) {
      document.body.appendChild(img);
      img.src = urlWithCb;
    } else {
      img.src = urlWithCb;
    }
  } catch (error) {
    AudacyLogger.debug(
      `[${LoggerTopic.Analytics}]: components/TapadPixel/index.tsx: firePixel: beacon failed: ${String(error)}`,
    );
  }
};

const TapadPixel = (): null => {
  useEffect(() => {
    const run = async () => {
      try {
        const cs = await getClientServices();
        await cs.onReady();
        const userToken = cs.getPersonalizationServices().userToken;
        const deviceId = cs.getPersonalizationServices().userDeviceId;
        const cookieId = userToken ?? deviceId;

        if (!cookieId || !(cookieId.startsWith('1ac') || cookieId.startsWith('f8k'))) {
          return;
        }

        const partnerId = isChromeBrowser() ? '3441' : '3547';
        const url = `https://pixel.tapad.com/idsync/ex/receive?partner_id=${partnerId}&partner_device_id=${encodeURIComponent(
          cookieId,
        )}`;

        firePixel(url);
      } catch (error) {
        AudacyLogger.debug(
          `[${LoggerTopic.Analytics}]: components/TapadPixel/index.tsx: TapadPixel exception occured: ${String(error)}`,
        );
      }
    };

    run();
  }, []);

  return null;
};

export default TapadPixel;
